import styled from 'styled-components';

export const SelectedConversationPlanContainer = styled.div`
  @media (max-width: 767px) {
    .dp-boxgrey .dp-price {
      margin: 8px 0 12px;
      position: static;
      width: auto;
    }

    .dp-boxgrey .dp-price h2 {
      font-size: 20px;
      line-height: 26px;
      margin: 0;
    }
  }
`;
